function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { pathOr } from 'ramda';
import { StatusConstants, i18n } from 'invision-core';
import CustomerCareLocaleKeys from './../../../../locales/keys';
import { SUBSCRIPTION_TABS, SUBSCRIPTION_STATUSES } from '../../../shared/constants/subscriptions.constants';
var SubscriptionItemController = /*#__PURE__*/function () {
  function SubscriptionItemController($timeout, $filter) {
    _classCallCheck(this, SubscriptionItemController);
    this.onMoreOptionClickedForItem = this.onMoreOptionClickedForItem.bind(this);
    this.removeDiscount = this.removeDiscount.bind(this);
    this.tabSelected = this.tabSelected.bind(this);
    this.$timeout = $timeout;
    this.$filter = $filter;
  }
  return _createClass(SubscriptionItemController, [{
    key: "$onInit",
    value: function $onInit() {
      this.localeKeys = CustomerCareLocaleKeys;
      this.DEFAULT_TABS = [{
        id: SUBSCRIPTION_TABS.INFO,
        active: true,
        glyph: 'info-circle'
      }, {
        id: SUBSCRIPTION_TABS.DISCOUNT,
        active: false,
        glyph: 'percent'
      }, {
        id: SUBSCRIPTION_TABS.PRICING_HISTORY,
        active: false,
        glyph: 'history'
      }, {
        id: SUBSCRIPTION_TABS.ADDITIONAL_INFO,
        active: false,
        glyph: 'plus'
      }];
      this.tabIds = SUBSCRIPTION_TABS;
      this.tabs = this.DEFAULT_TABS;
      this.redrawTrigger = false;
      this.selectedTabId = SUBSCRIPTION_TABS.INFO;
      this.updateTabs();
      if (this.item) {
        this.offerItemStatus = this.getOfferItemStatus(this.item.Status);
        this.effectiveDateTranslation = this.getEffectiveDateTranslation(this.item.EffectiveDate);
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.item) {
        this.updateTabs();
        if (this.localeKeys) {
          //translation can't be executed if this runs before onInit
          var subscriptionItem = changesObj.item.currentValue || {};
          this.offerItemStatus = this.getOfferItemStatus(subscriptionItem.Status);
          this.effectiveDateTranslation = this.getEffectiveDateTranslation(subscriptionItem.EffectiveDate);
        }
      }
    }
  }, {
    key: "discounts",
    get: function get() {
      return pathOr([], ['Discounts'], this.item);
    }
  }, {
    key: "hasDiscounts",
    value: function hasDiscounts() {
      return this.discounts.length > 0;
    }
  }, {
    key: "onMoreOptionClickedForItem",
    value: function onMoreOptionClickedForItem(moreOption) {
      this.onMoreOptionClicked()()(moreOption, this.item);
    }
  }, {
    key: "removeDiscount",
    value: function removeDiscount(discount) {
      this.onRemoveDiscount()()(discount);
    }
  }, {
    key: "periods",
    get: function get() {
      return pathOr([], ['PricingPeriods'], this.item);
    }
  }, {
    key: "hasPricingPeriods",
    value: function hasPricingPeriods() {
      return this.periods.length > 0;
    }
  }, {
    key: "hasInstanceProperties",
    value: function hasInstanceProperties() {
      return pathOr(false, ['InstanceProperties'], this.item);
    }
  }, {
    key: "updateTabs",
    value: function updateTabs() {
      var _this = this;
      if (!this.tabs) {
        return;
      }
      this.tabs = this.DEFAULT_TABS.filter(function (tab) {
        if (tab.id === SUBSCRIPTION_TABS.DISCOUNT) {
          return _this.hasDiscounts();
        } else if (tab.id === SUBSCRIPTION_TABS.PRICING_HISTORY) {
          return _this.hasPricingPeriods();
        } else if (tab.id === SUBSCRIPTION_TABS.ADDITIONAL_INFO) {
          return _this.hasInstanceProperties();
        } else {
          return true;
        }
      }).map(function (tab) {
        if (tab.id === SUBSCRIPTION_TABS.DISCOUNT) {
          tab.notificationCount = _this.discounts.length;
        }
        if (tab.id === SUBSCRIPTION_TABS.PRICING_HISTORY) {
          tab.notificationCount = _this.periods.length;
        }
        tab.active = _this.tabs.some(function (currentTab) {
          return currentTab && currentTab.active && currentTab.id === tab.id;
        });
        return tab;
      });
      this.setDefaultTab();
    }
  }, {
    key: "setDefaultTab",
    value: function setDefaultTab() {
      var hasActiveTab = this.tabs.some(function (tab) {
        return tab.active;
      });
      if (!hasActiveTab) {
        this.tabSelected(this.DEFAULT_TABS[0]);
      }
    }
  }, {
    key: "tabSelected",
    value: function tabSelected(item) {
      var _this2 = this;
      this.selectedTabId = item.id;
      this.tabs = this.tabs.map(function (tab) {
        tab.active = tab.id === _this2.selectedTabId;
        return tab;
      });
      this.$timeout(function () {
        _this2.redrawTrigger = !_this2.redrawTrigger;
      });
    }
  }, {
    key: "getOfferItemStatus",
    value: function getOfferItemStatus(subscriptionStatus) {
      var offerItemStatus = undefined;
      if (subscriptionStatus === SUBSCRIPTION_STATUSES.PENDING_ACTIVE) {
        offerItemStatus = StatusConstants.OFFER_STATUS_INDICATOR_STATUS.PENDING_ACTIVE;
      } else if (subscriptionStatus === SUBSCRIPTION_STATUSES.PENDING_REMOVED) {
        offerItemStatus = StatusConstants.OFFER_STATUS_INDICATOR_STATUS.PENDING_REMOVED;
      }
      return offerItemStatus;
    }
  }, {
    key: "getEffectiveDateTranslation",
    value: function getEffectiveDateTranslation(date) {
      if (!date) {
        return null;
      }
      return i18n.translate(this.localeKeys.SUBSCRIPTIONS.ITEM.EFFECTIVE_ON, {
        effectiveDate: this.$filter('localShortDate')(date)
      });
    }
  }]);
}();
export default {
  controller: SubscriptionItemController,
  template: require('./subscription.item.html'),
  bindings: {
    item: '<',
    moreOptions: '<',
    userCanRemove: '<',
    onMoreOptionClicked: '&',
    onRemoveDiscount: '&',
    subscription: '<'
  }
};